import React from "react";

import logo from './../../../assets/wp-content/uploads/2024/12/Universo-3-e1733142598393.png'
import logo2 from './../../../assets/wp-content/uploads/2024/12/Universo-3-e1733142598393-300x46.png'
import banner from './../../../assets/wp-content/uploads/2024/11/Design-sem-nome-16-e1732799515485.png'
import banner2 from './../../../assets/wp-content/uploads/2024/11/Design-sem-nome-16-e1732799515485-204x300.png'
import banner3 from './../../../assets/wp-content/uploads/2024/11/Design-sem-nome-16-e1732799515485-695x1024.png'
import banner4 from './../../../assets/wp-content/uploads/2024/11/Design-sem-nome-16-e1732799515485-768x1132.png'

class SectionUniverseSigmobi extends React.Component{
    render(){
        return(
            <section
              className="elementor-section elementor-top-section elementor-element elementor-element-55c6f2dd elementor-section-boxed elementor-section-height-default elementor-section-height-default"
              data-id="55c6f2dd"
              data-element_type="section"
              data-settings='{"background_background":"gradient","shape_divider_bottom":"waves","shape_divider_bottom_negative":"yes"}'
            >
              <div
                className="elementor-shape elementor-shape-bottom"
                data-negative="true"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1000 100"
                  preserveAspectRatio="none"
                >
                  <path
                    className="elementor-shape-fill"
                    d="M790.5,93.1c-59.3-5.3-116.8-18-192.6-50c-29.6-12.7-76.9-31-100.5-35.9c-23.6-4.9-52.6-7.8-75.5-5.3
                      c-10.2,1.1-22.6,1.4-50.1,7.4c-27.2,6.3-58.2,16.6-79.4,24.7c-41.3,15.9-94.9,21.9-134,22.6C72,58.2,0,25.8,0,25.8V100h1000V65.3
                      c0,0-51.5,19.4-106.2,25.7C839.5,97,814.1,95.2,790.5,93.1z"
                  />
                </svg>
              </div>
              <div className="elementor-container elementor-column-gap-default">
                <div
                  className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-2c7b8109"
                  data-id="2c7b8109"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-acb6102 elementor-widget elementor-widget-image"
                      data-id="acb6102"
                      data-element_type="widget"
                      data-widget_type="image.default"
                    >
                      <div className="elementor-widget-container">
                        <img
                          fetchPriority="high"
                          decoding="async"
                          width="600"
                          height="91"
                          src={logo}
                          className="attachment-full size-full wp-image-127"
                          alt=""
                          srcSet={`
                            ${logo}  600w,
                            ${logo2} 300w
                          `}
                          sizes="(max-width: 600px) 100vw, 600px"
                        />
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-6c9bfa64 elementor-widget elementor-widget-heading"
                      data-id="6c9bfa64"
                      data-element_type="widget"
                      data-widget_type="heading.default"
                    >
                      <div className="elementor-widget-container">
                        <h1 className="elementor-heading-title elementor-size-default">
                          Desfrute dos Benefícios de ser
                          <span > Sig</span>
                          <span >Mobi</span>
                        </h1>
                      </div>
                    </div>
                    <div
                      className="elementor-element elementor-element-37b0453 elementor-widget elementor-widget-text-editor"
                      data-id="37b0453"
                      data-element_type="widget"
                      data-widget_type="text-editor.default"
                    >
                      <div className="elementor-widget-container">
                        <p>
                          Para ver seu <strong>SALDO </strong>e indicações,
                          clique em &#8220;Escritório Virtual &#8221;no
                          final desta página.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-2ad94de"
                  data-id="2ad94de"
                  data-element_type="column"
                >
                  <div className="elementor-widget-wrap elementor-element-populated">
                    <div
                      className="elementor-element elementor-element-40e15a8b elementor-widget elementor-widget-image"
                      data-id="40e15a8b"
                      data-element_type="widget"
                      data-widget_type="image.default"
                    >
                      <div className="elementor-widget-container">
                        <img
                          decoding="async"
                          width="1000"
                          height="1474"
                          src={banner}
                          className="attachment-full size-full wp-image-44"
                          alt=""
                          srcSet={`
                            ${banner}          1000w,
                            ${banner2}   204w,
                            ${banner3}  695w,
                            ${banner4}  768w
                          `}
                          sizes="(max-width: 1000px) 100vw, 1000px"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
        );
    }
}   

export default SectionUniverseSigmobi;